import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ErrorPageContextType {
  isErrorPage: boolean;
  setIsErrorPage: (value: boolean) => void;
}

const ErrorPageContext = createContext<ErrorPageContextType | undefined>(undefined);

export const ErrorPageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isErrorPage, setIsErrorPage] = useState(false);

  return (
    <ErrorPageContext.Provider value={{ isErrorPage, setIsErrorPage }}>
      {children}
    </ErrorPageContext.Provider>
  );
};

export const useErrorPage = () => {
  const context = useContext(ErrorPageContext);
  if (context === undefined) {
    throw new Error('useErrorPage must be used within an ErrorPageProvider');
  }
  return context;
};

